import { createApiClient } from "Network/ApiClient";

export const SupplyLimitAxiosInstance = createApiClient("SupplyLimit/");
